<h1>Iniciar sesión</h1>

<div class="cuerpo"
  [class.vista-movil]="esResolucionMovil"
>
  <div class="form">
    <span class="titulo-formulario">Introduce tus datos de acceso a Unifersa.net:</span>

    <div class="inputs">
      <dx-text-box
        label="Correo Electrónico*"
        [formControl]="loginForm.controls.correo"
        [stylingMode]="stylingMode"
        [labelMode]="labelMode"
        [validationStatus]="validacionService.getFieldValidationState(loginForm.controls.correo)"
        [validationError]="loginForm.controls.correo.errors | validationErrorMessage"
        (onValueChanged)="onInputChange()"
        (keydown)="focusService.onKeyDown($event)"
      >
      </dx-text-box>
      <dx-text-box
        label="Contraseña*"
        [formControl]="loginForm.controls.clave"
        [stylingMode]="stylingMode"
        [labelMode]="labelMode"
        [mode]="passwordMode"
        [validationStatus]="validacionService.getFieldValidationState(loginForm.controls.clave)"
        [validationError]="loginForm.controls.clave.errors | validationErrorMessage"
        (onValueChanged)="onInputChange()"
        (keydown)="onKeydownContrasena($event)"
      >
        <dxi-button
          name="today"
          location="after"
          [options]="passwordButton"
        ></dxi-button>
      </dx-text-box>
    </div>

    <div class="acciones">
      <dx-check-box
        text="Mantener la sesión iniciada"
        [formControl]="loginForm.controls.recordar"
      >
      </dx-check-box>
      <button class="btn-olvide-contrasena" (click)="onRestablecerContra()">
        Olvidé mi contraseña
      </button>
    </div>
  </div>

  <div class="botonera">
    <button
      class="btn-iniciar-sesion"
      (click)="onSubmit()"
      [disabled]="loading"
    >
      Acceder
    </button>
  </div>
</div>
